import * as React from "react";
import { PlasmicCanvasHost } from "@plasmicapp/loader-nextjs";
import { PLASMIC } from "../plasmic-init";

function PlasmicHost() {
  return PLASMIC && <PlasmicCanvasHost />;
}

PlasmicHost.isPlasmicHost = true;

export default PlasmicHost;
